import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/slices/authSlice";
import { useFeedbackModal } from "../hooks/useFeedbackModal";
import { useGetCompanyKycStatusQuery } from "../redux/services/companyApi";

export const useDashboardLayoutController = (tourDone = true) => {
    const [hasMounted, setHasMounted] = useState(false);
    const user = useSelector(selectUser);
    const { isOpen: feedbackOpen, handleClose: closeFeedback, handleRemindLater: remindLaterFeedback, handleSubmit: submitFeedback } = useFeedbackModal(tourDone);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    // Approved = done. "pending" means they've already submitted and are waiting for
    // review, so don't ask them to submit again.
    const kycCompleted = Boolean(
        user?.kyc_verification === true ||
        user?.company?.kyc_verification === true ||
        user?.company?.kyc_status === "pending"
    );

    // Before blocking the dashboard, ask the backend (GET /company/get-company) —
    // the stored login data may be out of date. The query updates the stored user.
    const needsKycCheck = !kycCompleted && !!user?.company?.id;
    const kycCheck = useGetCompanyKycStatusQuery(undefined, {
        skip: !needsKycCheck,
        refetchOnMountOrArgChange: true,
    });
    const kycChecking = needsKycCheck && (kycCheck.isUninitialized || kycCheck.isLoading);

    const [kycDone, setKycDone] = useState(kycCompleted);

    useEffect(() => {
        if (kycCompleted) {
            setKycDone(true);
        }
    }, [kycCompleted]);

    const titleVariants = {
        initial: { opacity: 0, y: -10 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 10 },
    };

    return {
        titleVariants,
        hasMounted,
        kycDone,
        kycChecking,
        setKycDone,
        feedbackOpen,
        closeFeedback,
        remindLaterFeedback,
        submitFeedback,
    };
};